import { useTheme } from "styled-components";
import Layout from "../../../../components/layout/Layout";
import OverlayLoader from "../../../../components/loader/OverlayLoader/OverlayLoader";
import { useFrontofficeContext } from "../../../../context/FrontofficeContext";
import { useLanguageContext } from "../../../../context/LanguageContext";
import { StyledAltButton, StyledButton } from "../../../../styles/ButtonStyles";
import { StyledFlexColumn } from "../../../../styles/LayoutStyles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import {
  StyledEmployeeRegistrationButtonContent,
  StyledEmployeeRegistrationDescription,
  StyledEmployeeRegistrationGrid,
  StyledEmployeeRegistrationName,
  StyledEmployeeRegistrationPresence,
  StyledEmployeeRegistrationText,
} from "./EmployeeRegistrationPageStyles";
import HiddenLoader from "../../../../components/loader/HiddenLoader/HiddenLoader";

function EmployeeRegistrationPageView({
  departments,
  selectedDepartment,
  setSelectedDepartment,
  visibleDepartments,
  filteredEmployees,
  toggleEmployeePresence,
  isFetching,
}) {
  const { translate } = useLanguageContext();
  const { updatePage, terminal } = useFrontofficeContext();
  const theme = useTheme();

  return (
    <Layout
      layoutData={terminal?.layout}
      content={
        <StyledFlexColumn style={{ gap: theme.spacing.large }}>
          <HiddenLoader groups="employee_registration_fetch">
            <StyledFlexColumn>
              {/* Display departments selection text if there are visible departments */}
              {visibleDepartments.length > 0 && (
                <>
                  <StyledEmployeeRegistrationDescription>
                    {translate(
                      "eva.frontoffice.pages.employee_registration.departments",
                    )}
                  </StyledEmployeeRegistrationDescription>
                  <StyledEmployeeRegistrationText>
                    {translate(
                      "eva.frontoffice.pages.employee_registration.select_department",
                    )}
                  </StyledEmployeeRegistrationText>
                </>
              )}

              {/* Display that no departments are available if none are */}
              {departments.length === 0 && !isFetching && (
                <StyledEmployeeRegistrationText>
                  {translate(
                    "eva.frontoffice.pages.employee_registration.no_departments",
                  )}
                </StyledEmployeeRegistrationText>
              )}

              {/* Show visible departments based on the selected department */}
              {visibleDepartments.map((department) => (
                <StyledButton
                  key={department.id}
                  onClick={() => setSelectedDepartment(department)}
                >
                  {department.name}
                </StyledButton>
              ))}

              <StyledEmployeeRegistrationDescription>
                {translate("eva.frontoffice.pages.employee_registration.label")}
              </StyledEmployeeRegistrationDescription>
              <StyledEmployeeRegistrationText>
                {translate(
                  filteredEmployees.length > 0
                    ? "eva.frontoffice.pages.employee_registration.select_employee"
                    : "eva.frontoffice.pages.employee_registration.no_employees",
                )}
              </StyledEmployeeRegistrationText>

              {/* Show employees of selected department */}
              {filteredEmployees.length > 0 && (
                <StyledEmployeeRegistrationGrid>
                  {filteredEmployees.map((employee) => (
                    <OverlayLoader
                      key={employee.id}
                      groups={`employee_registration_toggle_${employee.id}`}
                      containerStyle={{ height: "100%" }}
                    >
                      <StyledButton
                        onClick={() => toggleEmployeePresence(employee)}
                        style={{ width: "100%", height: "100%" }}
                      >
                        {/* The name is at the top and the presence is always aligned at the bottom */}
                        <StyledEmployeeRegistrationButtonContent>
                          <StyledEmployeeRegistrationName>
                            {employee.first_name} {employee.last_name}
                          </StyledEmployeeRegistrationName>

                          <StyledEmployeeRegistrationPresence
                            $present={employee.present}
                          >
                            <FontAwesomeIcon
                              icon={faCircle}
                              style={{ fontSize: "0.6em" }}
                            />
                            {translate(
                              employee.present
                                ? "eva.frontoffice.pages.employee_registration.present"
                                : "eva.frontoffice.pages.employee_registration.absent",
                            )}
                          </StyledEmployeeRegistrationPresence>
                        </StyledEmployeeRegistrationButtonContent>
                      </StyledButton>
                    </OverlayLoader>
                  ))}
                </StyledEmployeeRegistrationGrid>
              )}
            </StyledFlexColumn>
          </HiddenLoader>
          {/* Back to start if department is selected, otherwise back to start of frontoffice page */}
          <StyledAltButton
            onClick={() => {
              if (selectedDepartment) {
                setSelectedDepartment(null);
              } else {
                updatePage("start");
              }
            }}
          >
            {translate("eva.frontoffice.general.back")}
          </StyledAltButton>
        </StyledFlexColumn>
      }
    />
  );
}

export default EmployeeRegistrationPageView;
